import { getCurrentUserApi } from "@/api";
import { IUserListResponse, IUserListTransformResponse } from "@/types";
import { MSALAUTH } from "@/utils/auth";
import { appQueryKey } from "@/utils/constant/appQueryKey";
import { useAccount, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import React from "react";

export const useGetCurrentUser = () => {
  const { accounts } = useMsal();
  const email = React.useMemo(() => {
    if (accounts.length > 0) {
      return accounts[0]?.username;
    }
    return "";
  }, [accounts]);

  return useQuery({
    queryKey: [appQueryKey.getCurrentUserDeatils, email],
    queryFn: () => getCurrentUserApi(email ?? ""),
    enabled: Boolean(email),
    staleTime: Infinity,
    retry: false,
    select: (data: IUserListResponse): IUserListTransformResponse => {
      const currentUser = data.value?.[0];
      const deafultRole =
        currentUser?.dogma_AppRole_SystemUser_SystemUser?.find(
          (item) => item.dogma_defaultsecurityrole,
        );
      const customRole = currentUser?.dogma_AppRole_SystemUser_SystemUser?.find(
        (item) => !item.dogma_defaultsecurityrole,
      );
      let permission = {};
      if (deafultRole?.dogma_permissionsjson) {
        const deafultPermission = JSON.parse(
          deafultRole?.dogma_permissionsjson,
        );
        permission = { ...deafultPermission };
      }
      if (customRole?.dogma_permissionsjson) {
        const customPermission = JSON.parse(customRole?.dogma_permissionsjson);
        permission = { ...customPermission };
      }
      return {
        ...data,
        defaultRole: deafultRole,
        customRole: customRole,
        permission: permission,
        currentUser: currentUser,
      };
    },
  });
};

export const useGetToken = () => {
  const [token, setToken] = React.useState("");
  const [user, setUserDetails] = React.useState({
    name: "",
    id: "",
  });
  const { instance, accounts } = useMsal();
  const account: any = useAccount(accounts[0] || {});
  const getToken = async () => {
    const tokenResponse = await MSALAUTH.getMslToken();
    const userDetails = JSON.parse(atob(tokenResponse?.split(".")?.[1] || ""));
    setToken(tokenResponse);
    setUserDetails({
      name: userDetails?.name,
      id: userDetails?.oid,
    });
  };
  React.useEffect(() => {
    if (account && account.username) getToken();
  }, [account, instance]);

  return { token, user };
};
